/*
|--------------------------------------------------------------------------
| Views: Visual Stories
|--------------------------------------------------------------------------
*/

/**
 * Visual Stories View
 * @namespace
 */
__gh__webApp.views.visualStories = {

	"callbacks": function(){
		__gh__webApp.utilities.parallax.init();
	},

	"getSubView": function(bucket){
		var items 			= (bucket.items.main) ? bucket.items.main : {},
			viewFolder 		= "buckets/visualStories",
			viewName 		= viewFolder+"/default";

		//Update bucket
		bucket.view.name 	= viewName;
		bucket.items 		= {
			"main"	: items.slice(0,1),
			"col1"	: items.slice(1,3),
			"col2"	: items.slice(3,4),
			"col3"	: items.slice(4,6)
		};
		return bucket;

	}
};